import styled from 'styled-components';

import { ErrorMessage, Field } from 'formik';
import PhoneInput from 'react-phone-input-2';

const DefaultPhone = (props) => {
    const {
        name,
        label,
        value,
        setFieldValue,
        styled = { width: '100%', borderColor: 'inherit' },
    } = props;

    // RETURN
    return (
        <InputWrapper>
            {label && <Label>{label}</Label>}
            <Field
                as={PhoneInput}
                name={name}
                value={value}
                onChange={(newValue) => {
                    setFieldValue(name, newValue);
                }}
                country={'ar'}
                countryCodeEditable={true}
                specialLabel={''}
                autoFormat={false}
                inputStyle={styled}
                {...props}
            />
            <ErrorMessage name={name} component={CustomError} />
        </InputWrapper>
    );
};

export default DefaultPhone;

const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 60px;
`;

const Label = styled.label`
    margin-bottom: 5px;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.54);
`;

const CustomError = styled.span`
    margin-top: 2px;
    font-size: 0.75rem;
    color: #b31d15;
`;
